import React, { useState } from 'react'
import {
  Button,
  FormGroup,
  Input,
  Label,
  Spinner
} from 'reactstrap'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import IssueCard from './IssueCard'
import projectStringsAlertsActions from '../ProjectStringsAlerts/actions'
import ValueDisplay from './ValueDisplay'

const DuplicateIssueCard = ({
  dispatch,
  issue,
  keepingStatus = 'idle',
  projectSlug
}) => {
  const { t } = useTranslation('ProjectsPage')
  const [selectedId, setSelectedId] = useState(null)
  const [isBusy, setIsBusy] = useState(false)

  const { key, locale, records } = issue

  const handleKeep = () => {
    if (!selectedId) return
    setIsBusy(true)
    dispatch(projectStringsAlertsActions.keep(projectSlug, selectedId))
  }

  // Reset busy state when operation completes
  if (keepingStatus === 'succeeded' && isBusy) {
    setIsBusy(false)
  }

  return (
    <IssueCard
      issueKey={key}
      issueType="duplicate"
      locale={locale}
      recordCount={records.length}
      subtitle={t('IssueCards.duplicate.subtitle')}
      title={t('IssueCards.duplicate.title')}
    >
      <p className="text-muted mb-3">
        {t('IssueCards.duplicate.description')}
      </p>

      <div className="duplicate-options">
        {records.map((record) => (
          <FormGroup
            key={record.id}
            check
            className={`p-3 mb-2 border rounded ${selectedId === record.id ? 'duplicate-option-selected' : 'bg-light'}`}
          >
            <Input
              type="radio"
              name={`duplicate-${key}-${locale}`}
              id={`option-${record.id}`}
              checked={selectedId === record.id}
              onChange={() => setSelectedId(record.id)}
              className="me-2"
            />
            <Label check for={`option-${record.id}`} className="w-100">
              <div className="d-flex flex-column">
                <code className="text-muted small">{record.relative_path}</code>
                <div className="mt-1">
                  <ValueDisplay value={record.value} />
                </div>
              </div>
            </Label>
          </FormGroup>
        ))}
      </div>

      <div className="d-flex justify-content-end mt-3">
        {isBusy ? (
          <Spinner size="sm" />
        ) : (
          <Button
            color="success"
            disabled={!selectedId}
            onClick={handleKeep}
            outline
          >
            {t('IssueCards.duplicate.keepSelected')}
          </Button>
        )}
      </div>
    </IssueCard>
  )
}

DuplicateIssueCard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  issue: PropTypes.shape({
    key: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    records: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      relative_path: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.bool,
        PropTypes.number,
        PropTypes.string
      ])
    })).isRequired
  }).isRequired,
  keepingStatus: PropTypes.string,
  projectSlug: PropTypes.string.isRequired
}

const mapStateToProps = ({
  projectStringsAlerts: { keepingStatus }
}) => ({ keepingStatus })

export default connect(mapStateToProps)(DuplicateIssueCard)
